import React from "react";

interface FeedbackTextAreaProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  errorMsg: string;
  placeholder: string;
  label: string;
}

const FeedbackTextArea: React.FC<FeedbackTextAreaProps> = ({ value, onChange, errorMsg, placeholder, label }) => {
  return (
    <div className="feedback-text-section">
      <label htmlFor="feedback-text">
        {label} <span className="required-text">*</span>
      </label>
      <textarea
        id="feedback-text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        aria-label="Feedback text"
        required
      />
      {errorMsg && <div className="error-message">{errorMsg}</div>}
    </div>
  );
};

export default FeedbackTextArea;
